// extracted by mini-css-extract-plugin
module.exports = {"preview":"Example_preview__24uaT","canvas":"Example_canvas__2abVy","examples":"Example_examples__D-3I2"};